import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" onClick={() => setOpen(false)}>🍳 Recetas</Link>
      </div>
      <button className="navbar-toggle" onClick={() => setOpen(!open)} aria-label="Abrir menú">
        {open ? '✕' : '☰'}
      </button>
      <div className={`navbar-menu ${open ? 'open' : ''}`}>
        {user ? (
          <>
            <span className="navbar-username">Hola, {user.username}</span>
            <Link to="/recipes/new" onClick={() => setOpen(false)}>+ Nueva receta</Link>
            {user.role === 'admin' && <Link to="/admin" onClick={() => setOpen(false)}>Admin</Link>}
            <button className="btn-link" onClick={handleLogout}>Cerrar sesión</button>
          </>
        ) : (
          <>
            <Link to="/login" onClick={() => setOpen(false)}>Iniciar sesión</Link>
            <Link to="/register" onClick={() => setOpen(false)}>Registrarse</Link>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
